/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRemediationActionDetails {
    getFixupPrototypeFunction() { return ResourceRemediationActionDetails.fixupPrototype; }

    static newInstance(model: Partial<ResourceRemediationActionDetails>): ResourceRemediationActionDetails {
        let obj = Object.assign(new ResourceRemediationActionDetails(), model);
        ResourceRemediationActionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRemediationActionDetails>): ResourceRemediationActionDetails {
        if (!model) return null;
        return ResourceRemediationActionDetails.newInstance(<ResourceRemediationActionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRemediationActionDetails) {
        if (!obj) return;

        models.ResourceRemediationActionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRemediationActionDetails): boolean {
        Object.setPrototypeOf(obj, ResourceRemediationActionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the remediation action triggered for the resource
     */
    action_name: string;

    /**
     * Unique ID of the remediation job triggered for the resource
     */
    job_id: string;

    /**
     * Indicates whether the remediation was triggered automatically (true) or manually by a user (false)
     */
    auto_triggered: boolean;

    /**
     * Reason explaining the current status of the remediation action
     */
    status_reason: string;

}
